function sanitizedRecommendations(recommendations: string) {
	return recommendations
		.replace('>', '')
		.replace(/<(?!.*<)/, '')
		.trim();
}

function formatOdontoRecommendations(recommendations: string[]) {
	if (!recommendations) {
		return [];
	}
	return recommendations.flatMap(recommendation => {
		if (recommendation.includes('\n')) {
			const recommendationArr = recommendation.split('\n');
			const sanitizedArr = recommendationArr.map(item => sanitizedRecommendations(item));
			return sanitizedArr;
		}
		const sanitizedArr = sanitizedRecommendations(recommendation);
		return sanitizedArr;
	});
}

export {formatOdontoRecommendations};
